import React from 'react';
import { Typography } from '@material-ui/core';

const Title = ({ children, variant = 'h5' }) => {
  return (
    <Typography
      variant={variant}
      style={{ fontFamily: 'Fredoka One, cursive' }}
    >
      {children}
    </Typography>
  );
};

export default Title;
